import type {
  EqualizeDomainService,
  FacetsDomainService,
  NextQueriesDomainService,
  PromotionDomainService,
  QueryRankingDomainService,
  RelatedTagsDomainService,
} from '../services/interfaces'
import type { DomainServiceProvider } from './interfaces/domain-service.provider'
import { interfaces } from 'inversify'
import { TYPES } from '../config/inversify.types'
import { FeatureIdEnum } from '../enums'

import Context = interfaces.Context

export function getPlatformDomainServiceProvider({ container }: Context): DomainServiceProvider {
  return (id: string) => {
    switch (id) {
      case FeatureIdEnum.EQUALIZE:
        return container.get<EqualizeDomainService>(TYPES.EqualizeDomainService)
      case FeatureIdEnum.NEXT_QUERIES:
        return container.get<NextQueriesDomainService>(TYPES.NextQueriesDomainService)
      case FeatureIdEnum.RELATED_TAGS:
        return container.get<RelatedTagsDomainService>(TYPES.RelatedTagsDomainService)
      case FeatureIdEnum.CONFIGURATION:
        return container.get<QueryRankingDomainService>(TYPES.QueryRankingDomainService)
      case FeatureIdEnum.FACETS:
        return container.get<FacetsDomainService>(TYPES.FacetsDomainService)
      case FeatureIdEnum.PROMOTION:
        return container.get<PromotionDomainService>(TYPES.PromotionDomainService)
      default:
        throw new Error(`Domain service provider not found for "${id}"`)
    }
  }
}
